<h2 mat-dialog-title>{{ 'SUBSIDIARY_CHANGE_WARNING.TITLE' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'SUBSIDIARY_CHANGE_WARNING.WILL_REQUIRE_PAYMENT_METHOD' | translate }}</p>
  <p>{{ 'SUBSIDIARY_CHANGE_WARNING.AVOID_TRANSACTION_DELAYS' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close color="primary">
    {{ 'SUBSIDIARY_CHANGE_WARNING.CONFIRM' | translate }}
  </button>
</mat-dialog-actions>
